import React from "react"
import { Box } from "@mui/material"
import { useNavigate } from "react-router-dom"

import { XFER } from "src/constants"
import { formatNumber } from "src/utils/parseStringToBigNumber"
import Text from "src/components/Text"
import Button from "src/components/Button"

import { useVaultsApr } from "../../hooks/useVaultsApr"

const EmptyView: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const navigate = useNavigate()
  const vaultsApr = useVaultsApr()
  const earnMaxApr =
    vaultsApr.length === 0
      ? 0
      : Math.max(...vaultsApr.map((x) => parseFloat(x.apr)))
  return (
    <Box display="flex" flexDirection="column" gap={3} py={2}>
      <Box alignSelf="center">
        <img src={XFER.icon} height="36px" />
      </Box>
      <Text>
        {"Seems like you don't have any xFER in your wallet to deposit."}
      </Text>
      <Text>
        You can stake FER to receive xFER, then deposit xFER into our vault to
        earn up to {formatNumber(earnMaxApr, 2, 2)}% APR on your FER!
      </Text>
      <Button
        onClick={() => {
          navigate("/stake")
          onClose()
        }}
        fullWidth
      >
        Stake FER and Get xFER
      </Button>
    </Box>
  )
}

export default EmptyView
